import React, { useEffect, useState, useRef } from "react";
import Footer from "./include/Footer";
import Header from "./include/Header";
import Sidebar from "./include/Sidebar";
import Pagination from "./include/Pagination";
import DateRangePickerComp from "./DateRangePickerComp";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useParams } from "react-router-dom";
import Loader from "./include/Loader";

const api_baseurl = process.env.REACT_APP_BASE_URL_API

function CustomerCreditCertificate() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setQuery] = useState("");
  const [searchDateRange, setDateRange] = useState("");
  const [finalDateValue, setFinalDateValue] = useState("");
  const [order, setOrder] = useState("ASC");

  const tableRef = useRef(null);

  const params = useParams();
  let vendor_id  = atob(params.vendor_id);

  const sorting = (col)=>{

    if(order === 'ASC'){
      const sorted = data.result.sort((a,b) =>
      
         col=='certificate_number' || col=='issued_amount' || col=='redeem_amount'
         ?
         a[col].toLowerCase()-b[col].toLowerCase()
         :
         a[col].toLowerCase() > b[col].toLowerCase()? 1: -1
        
      );
      
     // setData(sorted)
      setOrder("DSC")
    }

    if(order==='DSC'){
      const sorted = data.result.sort((a,b)=>
      col=='certificate_number' || col=='issued_amount' || col=='redeem_amount'
          ?
          b[col].toLowerCase() - a[col].toLowerCase()
          :
          a[col].toLowerCase() < b[col].toLowerCase()? 1: -1
       
      );
    // setData(sorted)
      setOrder("ASC")
    }
  }


  function parentAlert(demoData) {
    setDateRange(demoData);
    setFinalDateValue(searchDateRange);
  }

  useEffect(() => {
    getCalendarValue();

    loadData(finalDateValue);
  }, []);

  function loadData(datefilter) {
    setLoading(true);
    fetch(
      api_baseurl+"customer_credit_certificate?vendor_id=" +
        vendor_id +
        "&date_range=" +
        datefilter
    ).then((res) => {
      res.json().then((response) => {
        setData(response);
        setLoading(false);
      });
    });
  }

  function getCalendarValue() {
    setFinalDateValue(searchDateRange);
    // alert(finalDateValue)
    loadData(finalDateValue);
  }

  return (
    <fregment>
      <Header></Header>
      <Sidebar></Sidebar>

      <main id="main" className="main">
        <div className="pagetitle">
          <h1> Certificate</h1>
          <div className="seprator"></div>
          <nav className="export-relative">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="javascript:;">Customer Reports</a>
              </li>
              <li className="breadcrumb-item active"> Certificate</li>
            </ol>
            <a href={api_baseurl+"customer_credit_certificate?vendor_id="+vendor_id+"&date_range="+finalDateValue+"&is_download=1"}> <button className="export-data" ><i className="icon-excel"></i> Export Data</button></a>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="top-form">
                    <form>
                      <div className="row">
                        <div className="col date-ic">
                          <label for="selectdate"></label>
                          <DateRangePickerComp
                            alert={parentAlert}
                          ></DateRangePickerComp>
                          {/* <div className="calendar-ic">
                      <button type="button" onClick={getCalendarValue}><i className="icon-calendar-ic"></i></button>
                      </div> */}
                          <button
                            type="button"
                            className="go-btn"
                            onClick={getCalendarValue}
                          >
                            Go
                          </button>
                        </div>
                        <div className="col search-ic">
                          <label for="selectdate"></label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            onChange={(e) => setQuery(e.target.value)}
                          />
                          <div className="calendar-ic">
                            <button type="button">
                              <i className="icon-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  {/*  <!-- Table with stripped rows --> */}
                  {loading ? (
                    <Loader></Loader>
                  ) : (
                    <div className="table-responsive orderid-select">
                      <table
                        class="table table-striped table-bordered"
                        rel="tableRef"
                      >
                        <thead>
                          <tr>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("firstname")}
                              >
                                First Name
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("lastname")}
                              >
                                Last Name
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("phone")}
                              >
                                Phone
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("certificate_number")}
                              >
                                Certificate Number
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("service_name")}
                              >
                                Service
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("issued_amount")}
                              >
                                Issued Amount
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("issued_date")}
                              >
                                Issued Date
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("expire_date")}
                              >
                                Exp Date
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("redeem_amount")}
                              >
                                Redeemed Amount
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("redeem_date")}
                              >
                                Redeemed Date
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={()=>sorting("reason")}
                              >
                                Reason
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.result &&
                            data.result
                              .filter(
                                (item) =>
                                  item.firstname
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.lastname
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.phone
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.certificate_number
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.service_name
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.issued_amount
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.issued_date
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.expire_date
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.redeem_amount
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.redeem_date
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.reason
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase())
                              )
                              .map((item,index) => (
                                <tr
                                  id={index}
                                  key={index}
                                >
                                  <td>{item.firstname}</td>
                                  <td>{item.lastname}</td>
                                  <td>{item.phone}</td>
                                  <td>{item.certificate_number}</td>
                                  <td>{item.service_name}</td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.issued_amount).toFixed(2)}
                                  </td>
                                  <td>{item.issued_date}</td>
                                  <td>{item.expire_date}</td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.redeem_amount).toFixed(2)}
                                  </td>
                                  <td>{item.redeem_date}</td>
                                  <td>{item.reason}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {/* <!-- End Table with stripped rows --> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer></Footer>
    </fregment>
  );
}

export default CustomerCreditCertificate;
